import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Row, Col } from 'react-bootstrap';

interface OrderDateRangePickerProps {
  startDate: string; // Expect YYYY-MM-DD or empty string
  endDate: string; // Expect YYYY-MM-DD or empty string
  onDateRangeChange: (startDate: string, endDate: string) => void;
}

export function OrderDateRangePicker(props: OrderDateRangePickerProps) {
  const { startDate, endDate, onDateRangeChange } = props;

  const currentStartDateAsDate = startDate ? new Date(startDate) : null;
  const currentEndDateAsDate = endDate ? new Date(endDate) : null;

  const handleStartDateChange = (date: Date | null) => {
    const newStartDateString = date ? date.toISOString().split('T')[0] : '';
    // @ts-ignore - TypeScript doesn't recognize that endDate || '' is always a string
    onDateRangeChange(newStartDateString, endDate || '');
  };

  const handleEndDateChange = (date: Date | null) => {
    const newEndDateString = date ? date.toISOString().split('T')[0] : '';
    // @ts-ignore - TypeScript doesn't recognize that startDate || '' is always a string
    onDateRangeChange(startDate || '', newEndDateString);
  };

  return (
    <Row className="g-1 mx-0" style={{ width: '240px' }}>
      <Col className="pe-1" style={{ width: '120px' }}>
        <div className="small text-muted mb-1 text-nowrap">Start Date</div>
        <DatePicker
          selected={currentStartDateAsDate}
          onChange={handleStartDateChange}
          selectsStart
          startDate={currentStartDateAsDate}
          endDate={currentEndDateAsDate}
          dateFormat="yyyy-MM-dd"
          placeholderText="Start date"
          className="form-control form-control-sm bg-gray-50 hover:bg-gray-100 text-sm p-1"
          showPopperArrow={false}
        />
      </Col>
      <Col style={{ width: '120px' }}>
        <div className="small text-muted mb-1 text-nowrap">End Date</div>
        <DatePicker
          selected={currentEndDateAsDate}
          onChange={handleEndDateChange}
          selectsEnd
          startDate={currentStartDateAsDate}
          endDate={currentEndDateAsDate}
          dateFormat="yyyy-MM-dd"
          placeholderText="End date"
          className="form-control form-control-sm bg-gray-50 hover:bg-gray-100 text-sm p-1"
          showPopperArrow={false}
        />
      </Col>
    </Row>
  );
}
